import * as React from "react";
import { BaseFormElement, IBaseFormElementProps } from "../../../../../../react-core/Html/BaseFormElement";
import { ICheckboxEditorProps, CheckboxEditor } from "../../../../../../react-core/Html/CheckboxEditor";
import { CommonHelper } from "../../../../../../react-core/Helpers/CommonHelper";
import { PaymentType, SIPPPaymentInCheckboxGroupTexts } from "../Resource/Contents";

export interface ISIPPPaymentInCheckboxGroupProps extends IBaseFormElementProps {
    type: "inline" | "block" | "panel" | "sr-only" | "150";
    options: ICheckboxEditorProps[];
    title?: string | JSX.Element;
    wrapCss?: string;
    srTitle?: string;
}

export interface ISIPPPaymentInCheckboxGroupState {
    disable?: boolean;
}

export class SIPPPaymentInCheckboxGroup extends BaseFormElement<ISIPPPaymentInCheckboxGroupProps, ISIPPPaymentInCheckboxGroupState> {
    constructor(props: ISIPPPaymentInCheckboxGroupProps) {
        super(props);
        this.state = {};
    }

    public isValid() {
        return true;
    }

    public setDisable() {
        this.setState({ disable: true });
    }

    private getCheckbox(option: ICheckboxEditorProps, cssWrapper, index) {
        if (option !== null) {
            option.disabled = this.state.disable ? this.state.disable : option.disabled;
        } else {
            option = {};
            option.disabled = this.state.disable;
        }
        return <CheckboxEditor key={`checkbox-group-${index}`} {...option} cssWrapper={cssWrapper} />;
    }

    private getCheckboxes(options: ICheckboxEditorProps[], cssWrapper) {
        if (!CommonHelper.isNullOrEmpty(options) && options.length == 5) {
            if (options[0]?.label == "None" && 
                options[1]?.label == PaymentType.Client &&
                options[2]?.label == PaymentType.ThirdParty &&
                options[3]?.label == PaymentType.EmployerSalaryDeduction &&
                options[4]?.label == PaymentType.Employer) {

                return (
                    <div className="row">
                        <div className="col-12 col-lg-auto col-middle mt-13">
                            {this.getCheckbox(options[0], cssWrapper, 0)}
                        </div>
                        <div className="col-12 col-md-auto col-equalise">
                            <div className="panel-blue pl-20 pr-20">
                                <p className="text-size-12">{SIPPPaymentInCheckboxGroupTexts.TaxReliefSubtitle}</p>
                                <div className="row no-gutter">
                                    <div className="col-auto mr-18">{this.getCheckbox(options[1], cssWrapper, 1)}</div>
                                    <div className="col-auto mr-18">{this.getCheckbox(options[2], cssWrapper, 2)}</div>
                                    <div className="col-auto">{this.getCheckbox(options[3], cssWrapper, 3)}</div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-fluid col-equalise">
                            <div className="panel-blue pl-20 pr-20">
                                <p className="text-size-12">{SIPPPaymentInCheckboxGroupTexts.NoTaxReliefSubtitle}</p>
                                {this.getCheckbox(options[4], cssWrapper, 4)}
                            </div>
                        </div>
                    </div>
                );
            }
        } 
        return options.map((ele, index) => {
            return this.getCheckbox(ele, cssWrapper, index);
        });
    }

    public render(): JSX.Element {
        const { type, options, title, wrapCss, srTitle } = this.props;
        let wrapperCssNew = wrapCss + " ";
        switch (type) {
            case "inline":
                wrapperCssNew += "square-checkbox";
                break;
            case "150":
                wrapperCssNew += "checkbox-layout-150";
                break;
            case "panel":
                wrapperCssNew += "checkbox-panel";
                break;
            case "block":
                wrapperCssNew += "square-checkbox block";
                break;
            case "sr-only":
                wrapperCssNew += "square-checkbox label-sr-only";
                break;
            default:
                break;
        }

        const groups = this.getCheckboxes(options, wrapperCssNew);

        let groupCss = "form-group";
        if (type == "inline") {groupCss += "  checkbox-layout-inline";}

        if (type == "150") {
            if (!CommonHelper.isNullOrEmpty(options) && options.length == 5) {
                groupCss += " mb-9";
            }else{
                groupCss += " checkbox-layout-150 mb-9";
            }
        }

        return (
            <fieldset className={groupCss}>
                <legend className="sr-only">{title ? title : srTitle}</legend>
                <legend className="control-label">{title}</legend>
                <div className="controls-wrap">{groups}</div>
            </fieldset>
        );
    }
}
